<template>
    <oc-icon v-if="hint" :title="hint" type="question-circle" class="hint-question-icon" />
</template>

<script>
export default {
    name: 'oc-column-hints-after-column',
    inject: ['$source'],
    props: {
        title : {},
        field: {},
        hint: {
            default: null // from table-cell $attrs
        }
    }
}
</script>

<style scoped>
    .hint-question-icon{
        color:#b3b3b3;
        text-indent: 3px;
        font-size:15px;
        vertical-align: baseline;
    }
</style>
